import type { Baseline } from '@shared/models/project.model';
import { pruneDanglingActionReferences } from '../../actions/clean-actions.helpers';

/**
 * Delete a single {@link Action} from a {@link Baseline} and unlink it from every
 * {@link IProposal.actionIds} that referenced it.
 *
 * The proposals cleanup runs through {@link pruneDanglingActionReferences} so every
 * actionId resolves to an action after the mutation.
 *
 * Returns the same {@link version} reference when the action is missing.
 */
export const deleteAction = (version: Baseline, actionId: string): Baseline => {
  const actions = version.actions;
  if (!actions?.length) return version;

  const filtered = actions.filter((a) => a.id !== actionId);
  if (filtered.length === actions.length) return version;

  return pruneDanglingActionReferences({ ...version, actions: filtered });
};
